const removeAuth = () =>{
    localStorage.removeItem('userData')
    localStorage.removeItem('accessToken');
     localStorage.removeItem('logintype')
    localStorage.removeItem('usertype');
    
  }
  export {removeAuth}